var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2713 21.2586H27.1876V20.3023H28.2713C29.0363 20.3023 29.6738 19.6648 29.6738 18.8998V12.2061C29.6738 10.9948 28.6538 9.97483 27.4426 9.97483H20.4301C19.2188 9.97483 18.1988 10.9948 18.1988 12.2061V18.8998C18.1988 19.6648 18.8363 20.3023 19.6013 20.3023H20.6851V21.2586H19.6013C18.2626 21.2586 17.2426 20.1748 17.2426 18.8998V12.2061C17.2426 10.4211 18.6451 9.01858 20.4301 9.01858H27.5063C29.2913 9.01858 30.6938 10.4211 30.6938 12.2061V18.8998C30.6938 20.2386 29.6101 21.2586 28.2713 21.2586ZM23.9363 7.99858C22.0238 7.99858 20.4301 6.40483 20.4301 4.49233C20.4301 2.57983 22.0238 0.986084 23.9363 0.986084C25.8488 0.986084 27.4426 2.57983 27.4426 4.49233C27.4426 6.40483 25.9126 7.99858 23.9363 7.99858ZM23.9363 2.00608C22.5338 2.00608 21.3863 3.15358 21.3863 4.55608C21.3863 5.95858 22.5338 7.10608 23.9363 7.10608C25.3388 7.10608 26.4863 5.95858 26.4863 4.55608C26.4863 3.15358 25.3388 2.00608 23.9363 2.00608Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5937 30.6935C24.9562 30.6935 24.3825 30.3748 24 29.9285C23.6175 30.3748 23.0437 30.6935 22.4062 30.6935C21.2587 30.6935 20.3025 29.7373 20.3025 28.5898V13.0348H21.2587V28.5898C21.2587 29.2273 21.7687 29.7373 22.4062 29.7373C23.0437 29.7373 23.49 29.1635 23.49 28.5898V20.8123H24.4462V28.5898C24.4462 29.2273 24.9562 29.7373 25.5937 29.7373C26.2312 29.7373 26.7412 29.2273 26.7412 28.5898V13.0348H27.6975V28.5898C27.6975 29.7373 26.7412 30.6935 25.5937 30.6935Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7088 24.0636H1.05005V4.04614H19.0275V5.00239H2.0063V23.1074H18.7088V24.0636Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.585 12.9712H4.62V13.9274H15.585V12.9712Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.585 16.2224H4.62V17.1787H15.585V16.2224Z",
    fill: "#F5F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.585 19.5374H4.62V20.4936H15.585V19.5374Z",
    fill: "#F5F5F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6,
    height: 30.6,
    fill: "white",
    transform: "translate(0.540039 0.539917)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/Board.7c15f0edd51bfa9f8e52b597a6b36ec4.svg";
export { ForwardRef as ReactComponent };